module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_vietnam-fa09095c.png";